<template>
   <b-container>
       <b-row>
             <b-col class="text-center">
            <router-link to="/">Home</router-link> |
            <router-link to="/viewUnresolvedJobs">View Jobs</router-link> |
            <router-link to="/viewResolvetickets">View Tickets</router-link> |
            <router-link to="/createTicket">Create Tickets</router-link> 
            <br>
            <br>
            </b-col>
        </b-row>
        <b-row>
         <b-col class="text-center">
            <img src="img/logo.png" class="center-block" alt="EnergyDrive">
            </b-col>
        </b-row>
		<b-row >
             <b-col class="text-left">
			<h3>Pre Travel Booking</h3><hr>
        </b-col>
		</b-row>
        <b-row>
            <b-col>
                <br>
            </b-col>
        </b-row>
        <b-row>
            <b-form action="createNewFlightTicket" id="addCommentAction" method="get" v-on:submit.prevent >
                <b-col>
					<br><b>Client</b><br>
					<select class="form-control" id="selectClient" name="Client" style="overflow:scroll;" @change="selectClientChange" v-model="Client">
						<option disabled selected value="-1"> -- Select a site -- </option>
						<option v-for="site in sites"  v-bind:key="site.idSite" :value="site.idSite" >{{site.SiteName}}</option>		
						
					</select><br>
                    <select class="form-control" id="selectStage" name="Stage" style="overflow:scroll;" v-model="selectedDepartment">
						<option disabled selected value="-1"> -- Select stage of work -- </option>
						<option v-for="dep in departments"  v-bind:key="dep.idDepartment" :value="dep.idDepartment" >{{dep.Name}}</option>		
						
					</select><br>

					<b>Estimated Travel Date start</b>
                    <datetime v-model="TicketIssued"></datetime><br>
					
					
		
					<b>What are my Goals and Objectives of this travel?</b><textarea  rows="3" name="goals" id="id_Goals" class="form-control" v-model="goals"></textarea><br>
					<b>What outcomes am I expecting to achieve that would consider this travel an accomplished outcome?</b><textarea  rows="3" name="outcome" id="id_Outcome" class="form-control" v-model="outcome"></textarea><br>
					<b>Are you the best person for the Job?</b><br>
					<div class="checkbox">
                        <label><input type="checkbox"   id="bestPersonCheckbox" name="bestperson" v-model="bestperson">Yes I am.</label>
					</div><br>
					<b>Have I checked if there any open tickets relevant to this site that may or not be assigned to somebody else that can be resolved by myself in this same site visit?</b><br>
					<div class="checkbox">
                        <label><input type="checkbox" class="notickets" id="noTickets" name="notickets" v-model="notickets">Yes I have.</label>
					</div>
					<br>
					<b>Travel checked by </b><br><br>
					<select class="form-control" id="id_Employee" name="Employee" style="overflow:scroll;" v-model="Employee">
                        <option disabled selected value="-1"> -- Select a person -- </option>
                        <option v-for="emp in EmployeeList"  v-bind:key="emp.idEmployee" :value="emp.employee" >{{emp.employee}}</option>
					</select>
					<br>
                     <component-tagEmployee @updateEmployeeTagged="updateEmployeeTagged" :header="userTagHeader"></component-tagEmployee>
					<input type="submit" value="Submit Information" class="btn btn-primary" id="submitbtn" style="width:100%;" @click="submit">
                </b-col>
            </b-form>        
        </b-row> 
        <b-row>
            <b-col>
                <br>
            </b-col>
        </b-row>
   </b-container>
</template>
<script type="text/javascript">
  import axios from 'axios';
  import moment from 'moment';
  import tagEmp from '../components/tagEmployee.vue'
  export default {
  components: {
    'component-tagEmployee' : tagEmp
   },  
  data: () => ({
      EmployeeList : [],
      ListEmployeeTagged : [],
      sites : [],
      userTagHeader : "Add additional employees to this travel ticket : ",
      Client : -1,
      TicketIssued : null,
      departments : [],
      selectedDepartment : -1,
      goals : null,
      outcome : null,
      bestperson : null,
      notickets : null,
      Employee : -1

  }),
  methods: {
      submit : function()
      {
          // Do validation
        let validObject = true;
        let mainObject = this;
        var submitobject = new Object;
        submitobject.TicketIssued = this.TicketIssued;
        submitobject.goals = this.goals;
        submitobject.outcome = this.outcome;
        submitobject.bestperson = this.bestperson;
        submitobject.notickets = this.notickets;
        submitobject.selectedDepartment = this.selectedDepartment;
        submitobject.Employee = this.Employee;
        submitobject.employeeName =  localStorage.getItem('employee');
        submitobject.idemployee =  localStorage.getItem('idemployee');
        submitobject.Client = this.Client;
        submitobject.ListEmployeeTagged = this.ListEmployeeTagged;
        
        switch ( true )
        {
            case  ( (submitobject.Client == null)||( submitobject.Client < 1 ))  : 
                validObject = false;
                mainObject.showAlert("Please select a client.",2000,false);
                break;
            case  ( (submitobject.goals == null)||( submitobject.goals == ""))  : 
                validObject = false;
                mainObject.showAlert("Please fill in Goals and Objective section.",2000,false);
                break;
            case  ( (submitobject.outcome == null)||( submitobject.outcome == ""))  : 
                validObject = false;
                mainObject.showAlert("Please fill in Outcomes section.",2000,false);
                break;
            case  ( (submitobject.Employee == null)||( submitobject.Employee == -1))  : 
                validObject = false;
                mainObject.showAlert("Please select who checked travel.",2000,false);
                break;
            case  ( (submitobject.selectedDepartment == null)||( submitobject.selectedDepartment == -1))  : 
                validObject = false;
                mainObject.showAlert("Please select a stage of the work.",2000,false);
                break;
            case  ( (submitobject.notickets == null)||( submitobject.notickets == false))  : 
                validObject = false;
                mainObject.showAlert("Please check if there are any unresolved tickets before proceeding.",2000,false);
                break;
            case  ( (submitobject.bestperson == null)||( submitobject.bestperson == false))  : 
                validObject = false;
                mainObject.showAlert("Please tick that you are the best person for the job.",2000,false);
                break;
        
            default : validObject = true;
        }
        if ( validObject )
        {
            console.log("Travel valid")
             console.log(submitobject)
            
            axios.get(localStorage.getItem('ticketCopURL') +'/createNewFlightTicket', {
                params: {
                    data : submitobject
                },
                 headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
                console.log(response.data);
                if ( response.data.status == "Success")
                {
                    console.log(response.data);
                    ///console.log("Travel Ticket number "+data.idTicket+" was created. For you convienance this ticket number was emailed to the travel agent. No booking has been made yet. Please follow up with the travel agent to arrange your travel. ")
                    let text = "Travel Ticket nr " + response.data.idTicket + " was successfully created."
                    mainObject.$swal.fire(text).then((result) => {
                        console.log(result);
                        mainObject.$router.go(-1);
                        
                    })
                    //mainObject.showAlert(text,2000,false);
                }
                else
                {
                    console.log("Error was not able to insert travel info");
                    mainObject.showAlert("Error was not able to insert travel info.",2000,false);
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .then(function () {
         
                console.log("Done inserting ticket");
            });
        }
        else
        {
            console.log(submitobject)
            console.log("Failed Validation");
        }
      },

      selectClientChange : function()
      {
          // get all unresolved tickets for this site and display them 
          console.log("Client changed");

      }
      ,

      showAlert : function (msg,delay,gotoprevPage)
      {
        let timerInterval;
        let mainObject = this;
        mainObject.$swal({
        //title: 'Auto close alert!',
        html: msg,
        timer: delay,
        onBeforeOpen: () => {
            mainObject.$swal.showLoading()
            timerInterval = setInterval(() => {
            mainObject.$swal.getContent().querySelector('strong')
                
            }, 100)
        },
        onClose: () => {
            clearInterval(timerInterval)
        }
        }).then((result) => {
        if (
            // Read more about handling dismissals
            result.dismiss === mainObject.$swal.DismissReason.timer
        ) {
            if ( gotoprevPage )
            mainObject.$router.go(-1);
        }
        })  
      },
      updateEmployeeTagged : function(e)
      {
          this.ListEmployeeTagged = e;
          console.log("Main Component list")
          console.log(this.ListEmployeeTagged);
      }


  },
  created: function () {
        var objectMain = this;
        objectMain.TicketIssued = moment().toISOString();

      axios.get(localStorage.getItem('ticketCopURL') +'/getUsers', {
          params: {
           
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          console.log(response.data);
          objectMain.EmployeeList = response.data.users;
          
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
         
    });// end of axios call

    axios.get(localStorage.getItem('ticketCopURL') +'/getSites', {
          params: {
          
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          objectMain.sites = response.data;
          console.log(response);
          
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
         
    });// end of axios call

    axios.get(localStorage.getItem('ticketCopURL') +'/getDepartmentTicket', {
          params: {
            idTicket : objectMain.idTicket
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
         objectMain.departments = response.data;
          
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
         
    });// end of axios call

  }

  }
</script>


